export const AVATAR_GROUP_DEFAULTS = {
  /** Face avatars before the +N chip (fourth slot). */
  MAX_VISIBLE: 3,
  SIZE: 32,
  OVERLAP: 10,
} as const;
